/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_YouInputs */

const en_us2_clubs_you = /** @type {(inputs: Clubs_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you`)
};

const pt_br2_clubs_you = /** @type {(inputs: Clubs_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`você`)
};

const es_419_clubs_you = /** @type {(inputs: Clubs_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tú`)
};

const pt_pt2_clubs_you = /** @type {(inputs: Clubs_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu`)
};

const fr_fr2_clubs_you = /** @type {(inputs: Clubs_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`toi`)
};

const de_de2_clubs_you = /** @type {(inputs: Clubs_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du`)
};

const it_it2_clubs_you = /** @type {(inputs: Clubs_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu`)
};

/**
* | output |
* | --- |
* | "you" |
*
* @param {Clubs_YouInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_you = /** @type {((inputs?: Clubs_YouInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_YouInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_you(inputs)
	if (locale === "es-419") return es_419_clubs_you(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_you(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_you(inputs)
	if (locale === "de-DE") return de_de2_clubs_you(inputs)
	if (locale === "it-IT") return it_it2_clubs_you(inputs)
	return en_us2_clubs_you(inputs)
});
export { clubs_you as "clubs.you" }